import React from "react";

// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";
import { formatFinance } from "../../../utils/formatters";

export default function ItemRowWithCheckbox({
  complement,
  itemIndex,
  product,
  isSelected,
  setIsSelected,
}) {
  const [checked, setChecked] = React.useState(isSelected || false);
  const { complement_title, complement_price } = complement ?? {};

  const { product_title, product_price } = product ?? {};

  const title = complement?.title ?? product?.title ?? undefined;

  const price = complement?.price ?? product?.price ?? undefined;

  const handleChange = (event) => {
    setChecked(event.target.checked);
    setIsSelected(event.target.checked, itemIndex);
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={2}
      sx={{
        pl: 2,
        "&:hover": {
          backgroundColor: grey["200"],
        },
      }}
    >
      <Box>
        <Typography variant="body1">
          {complement_title || product_title || title || ""}
        </Typography>
      </Box>
      <Box>
        <Typography variant="caption">
          {formatFinance(
            parseFloat(complement_price || product_price || price)
          ) || ""}
        </Typography>
        <Checkbox
          checked={checked}
          onChange={handleChange}
          inputProps={{ "aria-label": "controlled" }}
        />
      </Box>
    </Stack>
  );
}
